import RegisterPartnerJsSerializer from './-json-api';

export default class RegistrationSerializer extends RegisterPartnerJsSerializer {}
